export default class ClientLossRstrDefinition {
  static getDefault = () =>
    new ClientLossRstrDefinition({
      clientLossRstr: false,
    });

  #clientLossRstr;


  constructor(props = {}) {
    const { clientLossRstr } = props;
    this.#clientLossRstr = clientLossRstr ?? false;

  }

  get clientLossRstr() {
    return this.#clientLossRstr;
  }

  setClientLossRstr = (value) =>
    new ClientLossRstrDefinition({ clientLossRstr: value });



  get complete() {
    return true;
  }

  get key() {
    return `Client Loss Restr -this.#clientLossRstr`;
  }

  copy = () => {
    return {
      clientLossRstr: this.clientLossRstr,

    };
  };
}
